import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DigitZeroPipe } from '../../../features/questionnaires/features/table-grid/pipes/digit-zero.pipe';
import { ContactTooltipComponent } from 'src/app/shared/components/contact-tooltip/contact-tooltip.component';
import { User } from 'src/app/models/user.model';
import { Recipient } from 'src/app/models/recipients.model';

@Component({
    selector: 'que-recipients-display',
    imports: [CommonModule, DigitZeroPipe, ContactTooltipComponent],
    templateUrl: './recipients-display.component.html',
    styleUrls: ['./recipients-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecipientsDisplayComponent {
  @Input()
  recipients?: User[];
  @Input()
  userCounts?: Map<number, number>;
  // @Input()
  // recipientsWithUsers?: Recipient[];
  @Input()
  isStatusReply: boolean = true;

  getUserCount(user: User): number {
    return this.userCounts?.get(user.id) || 1;
  }

  // ngOnInit(): void {
  //   if(!this.recipients && this.recipientsWithUsers){
  //     this.recipients=[...this.recipientsWithUsers.map(r=>r.user)];
  //   }
  // }
}
